import * as _ from 'lodash';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { PhoneService } from '@wephone-app-phone/services/phone/phone.service';
import { UserRepository } from '@wephone-core/model/repository/user';
import { PhoneBookRepository } from '@wephone-core/model/repository/phonebook';
import { ContactEntry } from '@wephone-core/model/entity/contact';
import { FormControl } from '@angular/forms';
import { regexSearch } from '@wephone-utils';
import { UserEntity } from '@wephone-core/model/entity/user';
import { PhoneBookEntry } from '@wephone-core/model/entity/phonebook';

@Component({
  selector: 'phone-book',
  templateUrl: 'phone-book.html',
  styleUrls: ['./phone-book.scss']
})
export class Phonebook implements OnInit {
  contacts = [];
  items = [];

  filterCtrl = new FormControl();

  @Input() showFilter: boolean;

  constructor(
    private readonly phoneService: PhoneService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    void this.processData();
  }

  ngOnInit(): void {
    this.filterCtrl.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    )
      .subscribe(value => {
        this.filterContacts(value);
      });
  }

  private async processData(): Promise<void> {
    const userRepo = UserRepository.getInstance();
    const phoneBookRepo = PhoneBookRepository.getInstance();
    const userList: UserEntity[] = await userRepo.findAll();
    const phoneBooks: PhoneBookEntry[] = await phoneBookRepo.findAll();

    const users = userList.filter(u => !u.system_user);
    let contacts: ContactEntry[] = users.map(u => {
      return new ContactEntry(u);
    });

    contacts = contacts.concat(phoneBooks.map(p => {
      return new ContactEntry(undefined, p);
    }));

    this.contacts = _.sortBy(contacts, [c => c.getFullName()]);
    this.setContacts(this.contacts);
  }

  private tranformAlphabetically(contacts): Object {
    const groupedCollection = {};
    for (const contact of contacts) {
      const firstLetter = contact.getFullName().charAt(0).toUpperCase();

      if (groupedCollection[firstLetter] === undefined) {
        groupedCollection[firstLetter] = [];
      }
      groupedCollection[firstLetter].push(contact);
    }

    return groupedCollection;
  }

  setContacts(contacts): void {
    this.items = contacts;
    this.cdr.markForCheck();
    return;
  }

  private filterContacts(value): void {
    if (value && value.trim() !== '') {
      const filterString = value.toLowerCase();
      const newContacts = this.contacts.filter(contact => {
        return regexSearch(contact.getFullName().toLowerCase(), filterString)
          || regexSearch(contact.getOfficeExtension(), filterString)
          || regexSearch(contact.getOfficePhoneNumber(), filterString)
          || regexSearch(contact.getOfficeNumber(), filterString)
          || regexSearch(contact.getMobileNumber(), filterString);
      });
      this.setContacts(newContacts);

      return;
    }
    this.setContacts(this.contacts);
  }

  makeCall(phoneNumber, event): void {
    // console.log('makeCall');
    event.stopPropagation();
    void this.phoneService.makeCall(phoneNumber);
  }
}
